import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import { IconFilledCircleSolid } from '@circlefin/euclid-icons/common';
import classNames from 'classnames';
import { Icon } from '../Icon/Icon.es.js';
import { Tooltip } from '../Tooltip/Tooltip.es.js';

const Chip = ({ variant, className, children, icon, tooltip, ...props })=>{
    const [type, color] = useMemo(()=>variant.split('/'), [
        variant
    ]);
    const isStatus = useMemo(()=>type === 'status', [
        type
    ]);
    const isIconOnly = useMemo(()=>!isStatus && icon && children == null, [
        children,
        icon,
        isStatus
    ]);
    const StatusIcon = useCallback(()=>{
        if (isStatus) {
            return jsx("span", {
                children: jsx(IconFilledCircleSolid, {
                    size: 8
                })
            });
        }
        if (icon) {
            return jsx("span", {
                "data-testid": "chip-icon",
                children: jsx(Icon, {
                    name: icon
                })
            });
        }
        return null;
    }, [
        icon,
        isStatus
    ]);
    return jsx(Tooltip, {
        arrowColor: "transparent",
        content: tooltip,
        hidden: tooltip == null,
        offset: 4,
        size: "sm",
        width: "hug",
        children: jsxs("span", {
            className: classNames('cb-chip', `cb-chip-${type}`, `cb-chip-${color}`, isIconOnly && 'cb-chip-icon-only', className),
            ...props,
            children: [
                jsx(StatusIcon, {}),
                children != null && jsx("span", {
                    className: "text",
                    children: children
                })
            ]
        })
    });
};
Chip.displayName = 'Chip';

export { Chip, Chip as default };
//# sourceMappingURL=Chip.es.js.map
